module.exports = __webpack_public_path__ + "Tail_feathers_DiffuseColor.d33214a.basis";